// extracted by mini-css-extract-plugin
export default {"wrapper":"PaymentPage_wrapper__UGrhE","pageHeader":"PaymentPage_pageHeader__JhhTo"};